export default __webpack_public_path__ + "static/media/wrong-icon.753e6134.svg";